import { RouteParcel } from "../../models/RouteParcel";

function RouteParcelView( { routeParcel, onSelected }: { routeParcel: RouteParcel, onSelected: (parcel: RouteParcel) => void }){

    const bgColor: string = GetBackgroundColor(routeParcel.parcelStatus);

    const handleSelected = (checked: boolean) => {
        routeParcel.selected = checked;
        onSelected(routeParcel);
    }

    let deliveryDateString = routeParcel.deliveryDate === null ? "" : new Date(routeParcel.deliveryDate).toLocaleDateString();

    return (
        <div className={`grid text-center text-black ${bgColor} border-black border-t-2 grid-cols-7 sm:grid-cols-10 lg:grid-cols-10`}>
            <div className="col-span-2                                                              lg:col-span-1">{routeParcel.scannedRoute}</div>
            <div className="col-span-2 order-5                                                      lg:col-span-1 lg:order-2">{routeParcel.assignedRoute}</div>
            <div className="col-span-2                                                              lg:col-span-1 lg:order-3">{routeParcel.controlNumber}</div>
            <div className="col-span-3 order-3              sm:col-span-4                           lg:col-span-3">{routeParcel.trackingNumber}</div>
            <div className="col-span-0 order-last invisible sm:col-span-2 sm:visible sm:order-5     lg:col-span-1 lg:order-6">{routeParcel.serviceType}</div>
            <div className="col-span-2 order-7              sm:col-span-4 sm:order-6                lg:col-span-1 lg:order-7">{routeParcel.deliveryZip}</div>
            <div className="col-span-2 order-6              sm:order-4                              lg:col-span-1 lg:order-5">{deliveryDateString}</div>
            <div className="col-span-1 order-8              sm:col-span-2                           lg:col-span-1">
                {routeParcel.canReroute && <input className="cursor-pointer" checked={routeParcel.selected} type="checkbox" onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSelected(e.target.checked)}></input>}
            </div>
        </div>
    )
}

function GetBackgroundColor(scanStatus: number) : string {
    switch(scanStatus)
    {
        case 0: return "bg-parcel-green-scan";
        case 1: return "bg-parcel-red-scan";
        case 2: return "bg-parcel-yellow-scan";
        case 3: return "bg-parcel-unscanned-with-inbound-blue";
        default: return "bg-white";
    }
}

export default RouteParcelView;